import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon, TrendingUp as TrendingUpIcon } from '@mui/icons-material';

const DatesRangeSection = ({ onUpdate, dateFieldOptions, boostInput = false }) => {
  const [currentDateFrom, setCurrentDateFrom] = useState('');
  const [currentDateTo, setCurrentDateTo] = useState('');
  const [dateField, setDateField] = useState(dateFieldOptions[0].id);
  const [boost, setBoost] = useState(1);

  const handleDateRangeAction = (actionType) => {
    if (!currentDateFrom && !currentDateTo) return;
    
    const updateData = {
      action: actionType,
      filter: 'date',
      field: dateField,
      value: {
        date_from: currentDateFrom,
        date_to: currentDateTo
      }
    };
    
    // Add boost value if boostInput is enabled
    if (boostInput) {
      updateData.boost = boost;
    }
    
    onUpdate(updateData);
    // Reset after adding
    setCurrentDateFrom('');
    setCurrentDateTo('');
  };

  return (
    <Box>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Date Field</InputLabel>
        <Select
          value={dateField}
          label="Date Field"
          onChange={(e) => setDateField(e.target.value)}
        >
          {dateFieldOptions.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          label="From"
          type="datetime-local"
          value={currentDateFrom}
          onChange={(e) => setCurrentDateFrom(e.target.value)}
          sx={{ flex: 1 }}
        />
        
        <TextField
          label="To"
          type="datetime-local"
          value={currentDateTo}
          onChange={(e) => setCurrentDateTo(e.target.value)}
          sx={{ flex: 1 }}
        />
      </Box>
      
      {boostInput && (
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          label="Boost"
          type="number"
          value={boost}
          onChange={(e) => setBoost(parseFloat(e.target.value) || 1)}
          inputProps={{ min: 0, step: 0.1 }}
        />
      )}
      
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleDateRangeAction('include')}
          disabled={!currentDateFrom && !currentDateTo}
        >
          <AddIcon />
        </Button>
        
        {boostInput && (
          <Button
            variant="contained"
            color="success"
            onClick={() => handleDateRangeAction('boost')}
            disabled={!currentDateFrom && !currentDateTo}
          >
            <TrendingUpIcon />
          </Button>
        )}
        
        <Button
          variant="contained"
          color="error"
          onClick={() => handleDateRangeAction('exclude')}
          disabled={!currentDateFrom && !currentDateTo}
        >
          <RemoveIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default DatesRangeSection;

